import * as React from "react";

export function useClusterIconCache() {
  const cacheRef = React.useRef<Record<string, google.maps.Icon>>({});

  return React.useCallback(
    (
      count: number,
      dimmed: boolean,
      hovered: boolean = false
    ): google.maps.Icon => {
      const css = getComputedStyle(document.documentElement);

      const getVar = (name: string, fallback: string) =>
        css.getPropertyValue(name).trim() || fallback;

      const bg = getVar("--button-ghost-color-bg", "#F8F4F0");

      const bgHover = getVar("--button-ghost-color-bg-hover", "#FFFFFF");

      const border = getVar("--button-ghost-color-border", "#320010");

      const opacity = dimmed ? 0.5 : 1;

      const BASE_W = 40;
      const BASE_H = 48;

      const MARKER_CENTER_X = 19.2861;
      const HEAD_CENTER_Y = 19.2;

      const baseHeight = count >= 100 ? 48 : count >= 10 ? 44 : 40;

      const outH = hovered ? baseHeight + 6 : baseHeight;

      const outW = Math.round(outH * (BASE_W / BASE_H));

      const key = [
        count,
        dimmed,
        hovered,
        bg,
        bgHover,
        border,
        outW,
        outH,
      ].join("|");

      if (!cacheRef.current[key]) {
        const svg = encodeURIComponent(`
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="${outW}"
            height="${outH}"
            viewBox="0 0 ${BASE_W} ${BASE_H}"
            fill="none"
          >
            <path
              d="M19.2861 2C23.8733 2.00011 28.2708 3.81445 31.5117 7.04102C34.7524 10.2674 36.5713 14.6413 36.5713 19.2002C36.5713 24.5146 33.5716 30.187 29.7451 35.1924C26.0092 40.0792 21.7219 44.0247 19.5068 45.9346C19.4413 45.9756 19.3656 45.9999 19.2861 46C19.2062 46 19.1293 45.976 19.0635 45.9346C16.8482 44.0245 12.5618 40.0787 8.82617 35.1924C4.99967 30.1871 2 24.5146 2 19.2002C2.00001 14.6413 3.81892 10.2674 7.05957 7.04102C10.3006 3.81436 14.6988 2 19.2861 2Z"
              fill="${hovered ? bgHover : bg}"
              fill-opacity="${opacity}"
              stroke="${border}"
              stroke-opacity="${opacity}"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        `);

        cacheRef.current[key] = {
          url: `data:image/svg+xml;charset=UTF-8,${svg}`,

          scaledSize: new google.maps.Size(outW, outH),

          anchor: new google.maps.Point(
            (MARKER_CENTER_X / BASE_W) * outW,
            outH
          ),

          labelOrigin: new google.maps.Point(
            (MARKER_CENTER_X / BASE_W) * outW,
            (HEAD_CENTER_Y / BASE_H) * outH
          ),
        };
      }

      return cacheRef.current[key];
    },
    []
  );
}
